import { useState, useEffect, useMemo } from 'react';
import DescriptionTip from '../../../../components/v2/DescriptionTip.jsx';

const HighPriorityTab = ({ eventTypes, selectedPriorityIds, onSave, saving }) => {
    const [selected, setSelected] = useState([]);

    // Sync from props when data reloads
    useEffect(() => {
        setSelected([...(selectedPriorityIds || [])]);
    }, [selectedPriorityIds]);

    // Sort event types alphabetically
    const sorted = useMemo(() => {
        return [...(eventTypes || [])].sort((a, b) =>
            (a.event_type_name || '').localeCompare(b.event_type_name || '')
        );
    }, [eventTypes]);

    const isDirty = useMemo(() => {
        const a = [...(selectedPriorityIds || [])].sort();
        const b = [...selected].sort();
        return JSON.stringify(a) !== JSON.stringify(b);
    }, [selected, selectedPriorityIds]);

    const toggleItem = (id) => {
        setSelected((prev) =>
            prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
        );
    };

    const handleSave = () => {
        onSave(selected);
    };

    const handleCancel = () => {
        setSelected([...(selectedPriorityIds || [])]);
    };

    return (
        <div className="pp-section">
            <div className="pp-section__header">
                <div>
                    <h2 className="pp-section__title">High Priority Events</h2>
                    <p className="ss-section-desc">
                        Select which event types should be flagged as high priority. High priority
                        events receive elevated visual indicators in the alert queue.
                    </p>
                </div>
                {isDirty ? (
                    <div className="pp-section__actions">
                        <button className="dp-btn dp-btn--cancel" onClick={handleCancel}>
                            Cancel
                        </button>
                        <button className="dp-btn dp-btn--primary" disabled={saving} onClick={handleSave}>
                            {saving ? 'Saving...' : 'Save Changes'}
                        </button>
                    </div>
                ) : null}
            </div>
            <div className="pp-section__body">
                {sorted.length === 0 ? (
                    <div className="ss-empty">
                        <p className="ss-empty__text">No event types available.</p>
                    </div>
                ) : (
                    <div className="ss-checkbox-grid">
                        {sorted.map((et) => (
                            <label key={et.event_type_id} className="ss-checkbox-item">
                                <input
                                    className="ss-checkbox-item__input"
                                    type="checkbox"
                                    checked={selected.includes(et.event_type_id)}
                                    onChange={() => toggleItem(et.event_type_id)}
                                />
                                <span className="ss-checkbox-item__label">
                                    {et.event_type_name}
                                    <DescriptionTip name={et.event_type_name} description={et.event_type_description} />
                                </span>
                            </label>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default HighPriorityTab;
